import { TASA_PESO } from "../constants";
import { useEffect, useState } from "react";

export function Currency({ price, cy }) {
  const [formattedPrice, setFormattedPrice] = useState("");

  useEffect(() => {
    setFormattedPrice(`$${price ? (price).toFixed(2) : (0).toFixed(2)}`);
    if (cy === "CUP") {
      setFormattedPrice(`${price ? (price * TASA_PESO).toFixed(2) : (0).toFixed(2)} CUP`);
    }
  }, []);

  return formattedPrice;
}